// Accordion-style click-to-toggle for mega menu items with sub-menus
// Uses event delegation so it works with dynamically loaded content

(function() {
  'use strict';

  let isInitialized = false;
  let clickHandlerAttached = false;
  let clickOutsideHandlerAttached = false;
  const observedColumns = new WeakSet();

  function syncMegaMenuFlowLayout(menuItem) {
    if (!menuItem) return;

    let lazyMenu = menuItem.closest('.t4s-type__mega .t4s-lazy_menu');
    if (!lazyMenu && menuItem.classList && menuItem.classList.contains('t4s-lazy_menu')) {
      lazyMenu = menuItem;
    }
    if (!lazyMenu) return;

    lazyMenu.style.height = 'auto';

    lazyMenu.querySelectorAll('.t4s-sub-column-item').forEach(function(el) {
      el.style.removeProperty('position');
      el.style.removeProperty('left');
      el.style.removeProperty('top');
      el.style.removeProperty('right');
      el.style.removeProperty('transform');
    });
  }

  function scheduleMegaMenuFlowSync(menuItem) {
    syncMegaMenuFlowLayout(menuItem);
    requestAnimationFrame(function() {
      syncMegaMenuFlowLayout(menuItem);
      setTimeout(function() {
        syncMegaMenuFlowLayout(menuItem);
      }, 320);
    });
  }

  function observeLinkColumn(column) {
    if (!column || observedColumns.has(column) || typeof ResizeObserver === 'undefined') {
      return;
    }

    observedColumns.add(column);

    const observer = new ResizeObserver(function() {
      scheduleMegaMenuFlowSync(column);
    });

    observer.observe(column);
  }

  function setupMegaMenuObservers(root) {
    const scope = root || document;
    scope.querySelectorAll('.t4s-type__mega .type_mn_link.t4s-sub-column-item').forEach(observeLinkColumn);
    scope.querySelectorAll('.t4s-type__mega .t4s-lazy_menu').forEach(function(lazyMenu) {
      syncMegaMenuFlowLayout(lazyMenu);
    });
  }

  function handleToggleClick(e) {
    const toggleBtn = e.target.closest('.t4s-menu-toggle');
    const iconSpan = e.target.closest('.t4s-menu-toggle-icon');
    const actualToggleBtn = toggleBtn || (iconSpan ? iconSpan.closest('.t4s-menu-toggle') : null);

    if (!actualToggleBtn) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const menuItem = actualToggleBtn.closest('.t4s-menu-item.has--children');
    if (!menuItem) {
      return;
    }

    const inMegaMenu = menuItem.closest('.t4s-sub-column, .t4s-sub-menu');
    if (!inMegaMenu) {
      return;
    }

    const linkColumn = menuItem.closest('.type_mn_link');
    const subMenu = menuItem.querySelector('ul.t4s-sub-menu-2');
    const icon = actualToggleBtn.querySelector('.t4s-menu-toggle-icon');

    if (!subMenu || !icon) {
      return;
    }

    const isActive = menuItem.classList.contains('menu-item-active');
    const parentUl = subMenu.parentElement.closest('ul');

    if (parentUl) {
      parentUl.querySelectorAll('.t4s-menu-item.has--children.menu-item-active').forEach(function(item) {
        if (item !== menuItem) {
          item.classList.remove('menu-item-active');
          const otherSubMenu = item.querySelector('ul.t4s-sub-menu-2');
          const otherIcon = item.querySelector('.t4s-menu-toggle-icon');
          if (otherSubMenu) {
            otherSubMenu.style.maxHeight = '0';
            otherSubMenu.style.paddingTop = '0';
            otherSubMenu.style.paddingBottom = '0';
          }
          if (otherIcon) otherIcon.textContent = '+';
          const otherToggle = item.querySelector('.t4s-menu-toggle');
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    if (isActive) {
      menuItem.classList.remove('menu-item-active');
      actualToggleBtn.setAttribute('aria-expanded', 'false');
      icon.textContent = '+';
      subMenu.style.maxHeight = '0';
      subMenu.style.paddingTop = '0';
      subMenu.style.paddingBottom = '0';
    } else {
      menuItem.classList.add('menu-item-active');
      actualToggleBtn.setAttribute('aria-expanded', 'true');
      icon.textContent = '−';
      subMenu.style.maxHeight = 'none';
      const expandedHeight = subMenu.scrollHeight;
      subMenu.style.maxHeight = expandedHeight + 'px';
      subMenu.style.paddingTop = '8px';
      subMenu.style.paddingBottom = '8px';
    }

    if (linkColumn) observeLinkColumn(linkColumn);
    scheduleMegaMenuFlowSync(linkColumn || menuItem);
  }

  function closeAllMenus() {
    let relayoutFrom = null;

    document.querySelectorAll('.t4s-accordion-menu .t4s-menu-item.has--children.menu-item-active').forEach(function(item) {
      if (!relayoutFrom) relayoutFrom = item.closest('.type_mn_link') || item;
      item.classList.remove('menu-item-active');
      const subMenu = item.querySelector('ul.t4s-sub-menu-2');
      const icon = item.querySelector('.t4s-menu-toggle-icon');
      if (subMenu) {
        subMenu.style.maxHeight = '0';
        subMenu.style.paddingTop = '0';
        subMenu.style.paddingBottom = '0';
      }
      if (icon) icon.textContent = '+';
      const toggle = item.querySelector('.t4s-menu-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });

    if (relayoutFrom) scheduleMegaMenuFlowSync(relayoutFrom);
  }

  function initAccordion() {
    if (isInitialized) {
      return;
    }

    if (window.innerWidth <= 768) {
      return;
    }

    isInitialized = true;
    setupMegaMenuObservers(document);

    if (!clickHandlerAttached) {
      document.addEventListener('click', handleToggleClick, true);
      clickHandlerAttached = true;
    }

    if (!clickOutsideHandlerAttached) {
      document.addEventListener('click', function clickOutside(e) {
        const megaMenuContainer = e.target.closest('.t4s-sub-menu, .type_mn_link');
        if (!megaMenuContainer) {
          closeAllMenus();
        }
      }, false);
      clickOutsideHandlerAttached = true;
    }

    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (window.innerWidth <= 768) {
          closeAllMenus();
        } else {
          setupMegaMenuObservers(document);
        }
      }, 250);
    });
  }

  function watchLazyMegaMenus() {
    document.querySelectorAll('.t4s-type__mega .t4s-lazy_menu').forEach(function(lazyMenu) {
      if (lazyMenu.dataset.flowObserverAttached) return;
      lazyMenu.dataset.flowObserverAttached = 'true';

      const mo = new MutationObserver(function() {
        setupMegaMenuObservers(lazyMenu);
        const firstLinkColumn = lazyMenu.querySelector('.type_mn_link');
        if (firstLinkColumn) {
          scheduleMegaMenuFlowSync(firstLinkColumn);
        } else {
          syncMegaMenuFlowLayout(lazyMenu);
        }
      });

      mo.observe(lazyMenu, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAccordion();
      watchLazyMegaMenus();
    });
  } else {
    initAccordion();
    watchLazyMegaMenus();
  }

  setTimeout(function() {
    if (!isInitialized && window.innerWidth > 768) {
      initAccordion();
    }
    watchLazyMegaMenus();
    setupMegaMenuObservers(document);
  }, 1000);

  window.scheduleMegaMenuRelayout = scheduleMegaMenuFlowSync;
})();
